:host {
    display: block;
    color: var(--color-title-1);
    font-size: 36px;
    font-weight: 100;
    margin-bottom: 32px;
}
